// extracted by mini-css-extract-plugin
module.exports = {"root":"MeetupLogo_root__3kSyZ"};